import React, { Fragment, PureComponent } from 'react';
import {
	BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';

import { StyledSimpleBarChart } from './style/StyledSimpleBarChart';

import { SelectColor } from '../../../../services/reports';

function CustomTooltip({ payload, active, channel }) {
	if (active) {
		return (
			<div className="custom-tooltip">
				<strong className="label m-0">{payload[0].payload.name}</strong>
				<div>
					{
						payload[0].payload.clicks ? (
							<p className={`label m-0 label-clicks element-${channel}`}>Cliques: {`${payload[0].payload.clicks}`}</p>
						) : null
					}

					{
						payload[0].payload.impressions ? (
							<p className={`label m-0 label-impressions element-${channel}`}>Impressões: {(payload[0].payload.impressions)}</p>
						) : null
					}
				</div>
			</div>
		);
	}

	return null;
}

export default class Example extends PureComponent {
	translate = (title) => {
		const data = {
			men: 'Homens',
			woman: 'Mulheres',
			clicks: 'Cliques',
			impressions: 'Impressões',
		};

		return data[title];
	};

	render() {
		const { data, typeChart, channel } = this.props;

		return (
			<Fragment>
				<StyledSimpleBarChart channel={channel} className={`simple-bar-chart ${typeChart === 'CampaignRange' ? 'campaign-range' : 'bar-chart'}`}>
					<div style={{ width: '100%', height: 350 }}>
						<ResponsiveContainer width="100%" debounce={1}>
							<BarChart
								data={data}
								barCategoryGap={500}
								layout="vertical"
								margin={{
									top: 20, right: 30, left: 20, bottom: 20,
								}}
								width="100%"
							>
								<XAxis xAxisId="left" type="number" dataKey="clicks" barPercentage={0.1} margin={{ top: 20, bottom: 20 }} dx={-10} interval={0} />

								{
									data[0].impressions ? (
										<XAxis xAxisId="right" orientation="top" type="number" dataKey="impressions" barPercentage={0.1} margin={{ top: 20, bottom: 20 }} dx={-10} interval={0} />
									) : null
								}

								<YAxis type="category" dataKey="name" margin={{ top: 20, bottom: 20 }} dx={-10} interval={0} />
								<CartesianGrid strokeDasharray="3 3" />
								<Tooltip content={<CustomTooltip channel={channel} />} />

								{
									data.map((valueChart, indice) => {
										if (indice === 0) {
											return Object.keys(valueChart).filter(value => value !== 'name').map(title => (
												<Bar
													barSize={30}
													dataKey={title}
													margin={{
														top: 20, right: 0, left: 0, bottom: 20,
													}}
													fill={SelectColor(channel, title)}
													name={this.translate(title)}
													type="monotone"
													xAxisId={(title === 'clicks') ? 'left' : 'right'}
												/>
											));
										}

										return false;
									})
								}
							</BarChart>
						</ResponsiveContainer>

						{(typeChart === 'GenderOrAgesPerformance') ? (
							<div className="legend legend-simple">
								{
									data[0].clicks ? (
										<div className="topic-1">
											Cliques
										</div>
									) : null
								}

								{
									data[0].impressions ? (
										<div className="topic-2">
											Impressões
										</div>
									) : null
								}
							</div>
						) : null}
					</div>
				</StyledSimpleBarChart>
			</Fragment>
		);
	}
}
